export const IMPORT_SERVICES = 'IMPORT_SERVICES';
export const IMPORT_SINGLE_SERVICE = 'IMPORT_SINGLE_SERVICE';
export const UPDATE_SERVICE = 'UPDATE_SERVICE';
export const UPDATE_SERVICE_ORDER = 'UPDATE_SERVICE_ORDER';
export const ADD_SERVICE = 'ADD_SERVICE';
export const DELETE_SERVICE = 'DELETE_SERVICE';

export const STEPS = {
  details: 'details',
  assignments: 'assignments',
};
